/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { Container, Wrapper } from './styles/EnquiryForm.styled';
import { Row } from './styles/Row.styled';
import {
  EnquiryFormSection,
  EnquiryFormHeading,
  FormGroup,
  FormRow,
  RadioButton,
  RadioButtonHeading,
} from './styles/EnquiryFormBlock.styled';
import { Column, ColumnForm } from './styles/Column.styled';
import { ButtonDiv, Button } from './styles/Button.styled';
import EnquiryFormInput from './EnquiryFormInput';
import EnquiryFormSelect from './EnquiryFormSelect';
import EnquiryFormCheckbox from './EnquiryFormCheckbox';

export default function LeasePropertyForm({ dir, id }) {
  const [selectValue, setSelectValue] = useState('Please select ...');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [checkbox, setCheckbox] = useState('');

  const inputValues = [
    {
      label: 'Title*',
      value: selectValue,
      setValue: setSelectValue,
      type: 'select',
      options: ['Please select ...', 'Mr.', 'Mrs.', 'Ms.', 'Dr.'],
    },
    {
      label: 'First Name*',
      value: firstName,
      setValue: setFirstName,
      required: true,
      type: 'text',
    },
    {
      label: 'Last Name*',
      value: lastName,
      setValue: setLastName,
      required: true,
      type: 'text',
    },
    {
      label: 'Email Address*',
      value: email,
      setValue: setEmail,
      required: true,
      type: 'text',
    },
    {
      label: 'Telephone *',
      value: email,
      setValue: setEmail,
      required: true,
      type: 'number',
    },
    {
      label: 'Company Name*',
      value: email,
      setValue: setEmail,
      required: true,
      type: 'text',
    },
    {
      label: 'Number of Employees*',
      value: email,
      setValue: setEmail,
      required: true,
      type: 'number',
    },
    {
      label: 'I am interested in a Free Zone Licence*',
      value: checkbox,
      setValue: setCheckbox,
      required: true,
      type: 'checkbox',
      options: ['yes', 'no'],
    },
  ];

  return (
    <Container id={id}>
      <Wrapper>
        {inputValues.map(({ label, value, setValue, required, type, options }) => {
          switch (type) {
            case 'select':
              return (
                <EnquiryFormSelect
                  options={options}
                  isRequired={required}
                  title={label}
                  value={value}
                  setValue={setValue}
                />
              );
            case 'checkbox':
              return (
                <EnquiryFormCheckbox
                  options={options}
                  isRequired={required}
                  title={label}
                  value={value}
                  setValue={setValue}
                />
              );
            default:
              return <EnquiryFormInput title={label} isRequired={required} type={type} />;
          }
        })}
      </Wrapper>
      <Button stylevariant="green" href="" target="_self" rel="" dir={dir}>
        Submit
      </Button>
    </Container>
  );
}
